/**
 * The single verified sender address used for ALL outgoing email.
 *
 * The API enforces this server-side (MAIL_FROM, via VerifiedSenderEmailService) —
 * this constant only mirrors it for display in read-only "From" fields. Keep it
 * in sync with the API's MAIL_FROM; override per environment with VITE_MAIL_FROM.
 */
export const VERIFIED_SENDER_EMAIL =
  import.meta.env.VITE_MAIL_FROM || 'no-reply@ministryofwine.co.nz';
